import { ClientStatus } from "creso-core/types";
import { convertSnakeCaseToTitleCase } from "creso-core/utils";
import { Badge, cn } from "web-design-system";

export const ClientStatusBadge = ({
  status,
  className,
}: {
  status: ClientStatus;
  className?: string;
}) => {
  const statusForView =
    status === "VERIFICATION_PENDING"
      ? "LEAD"
      : ["UNDER_REVIEW", "AUTHENTICATION_PENDING"].includes(status)
        ? "SETUP_PENDING"
        : ["UPDATE_PENDING", "UPDATE_UNDER_REVIEW"].includes(status)
          ? "ACTIVE"
          : status;
  return (
    <Badge
      variant="custom"
      className={cn(
        statusForView === "ACTIVE" && "bg-tag-green text-tag-green-foreground",
        statusForView === "SETUP_PENDING" &&
          "bg-tag-orange text-tag-orange-foreground",
        statusForView === "INACTIVE" && "bg-tag-red text-tag-red-foreground",
        statusForView === "LEAD" && "bg-tag-slate text-tag-slate-foreground",
        className
      )}
    >
      {convertSnakeCaseToTitleCase(statusForView.toString())}
    </Badge>
  );
};
